var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PDFViewerBrowser"},[_c('div',{staticClass:"hearderBox"},[_c('span',{on:{"click":_vm.backPath}},[(_vm.isWxWork)?[_vm._v("返回")]:_c('Svgs',{attrs:{"name":"iconfanhui","color":"#000"}})],2)]),_c('div',[_c('iframe',{ref:"h5Frame",staticClass:"h5Frame",attrs:{"src":_vm.iframeUrl,"id":"h5Frame"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }